<script lang="ts">
  import axios from "axios";
  import Window from "../components/Window.svelte";
  import { onMount } from "svelte";
  import type { WinCbs, WinProps } from "../scripts/WinTypes";
  import { getStorage, setStorage } from "../scripts/utils";
  import Loading from "../components/Loading.svelte";

  export let primaryColor: string = "white";
  export let secondaryColor: string = "black";
  export let winProps: WinProps;
  winProps.name = winProps.name || "Postman";
  export let callbacks: WinCbs;
  const _post = async (cmd: string, val1, val2) => {
    const res = await axios
      .post(cmd, {
        email: val1,
        password: val2,
      })
      .then((_) => _)
      .catch((err) => log("Error : " + err));
    if (res) {
      console.log("Cookie : ", document.cookie);
      log("Response : " + JSON.stringify(res));
    }
    console.log(res);
  };
  const post1 = () => {
    setStorage("workValue1", workValue1);
    setStorage("email1", email1);
    setStorage("password1", password1);
    _post(workValue1, email1, password1);
  };
  const post2 = async () => {
    setStorage("workValue2", workValue2);
    setStorage("email2", email2);
    setStorage("password2", password2);
    _post(workValue2, email2, password2);

    const res = await axios
      .post(workValue2, {
        instance_name: "df",
        instance_type: "asdf",
      })
      .then((_) => _)
      .catch((err) => log("Error : " + err));
    if (res) {
      log("Response data : " + JSON.stringify(res.data));
      log("Full response : " + JSON.stringify(res));
    }
    console.log(res);
  };
  onMount(() => {
    if (0) {
      function deleteAllCookies() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
      }
      deleteAllCookies();
    }
    axios.defaults.withCredentials = true;
  });
  let workValue1 = getStorage("workValue1") || "http://localhost:8080/login";
  let workValue2 = getStorage("workValue2") || "http://localhost:8080/create";
  let email1 = getStorage("email1"),
    email2 = getStorage("email2"),
    password1 = getStorage("password1"),
    password2 = getStorage("password2");
  let results = [];
  const log = (str) => {
    results = [str, ...results];
  };
  const _get = async (url) => {
    const res = await axios
      .get(url)
      .then((_) => _)
      .catch((err) => log("Error : " + err));
    if (res) {
      log("Response : " + JSON.stringify(res));
    }
  };
  const get1 = () => {
    setStorage("getValue1", getValue1);
    _get(getValue1);
  };
  const get2 = () => {
    setStorage("getValue2", getValue2);
    _get(getValue2);
  };
  const get3 = () => {
    setStorage("getValue3", getValue3);
    _get(getValue3);
  };
  const get4 = () => {
    setStorage("getValue4", getValue4);
    _get(getValue4);
  };
  let getValue1 = getStorage("getValue1") || "http://localhost:8080/",
    getValue2 = getStorage("getValue2") || "http://localhost:8080/",
    getValue3 = getStorage("getValue3") || "http://localhost:8080/",
    getValue4 = getStorage("getValue4") || "http://localhost:8080/";
  let inputs = [];
</script>

<Window {winProps} {callbacks}>
  <div class="container">
    <h1 class="title">POST MAN</h1>
    <div class="workbench">
      <div class="item">
        <h1>Workbench 1</h1>
        <form on:submit|preventDefault={post1}>
          Post address :
          <textarea rows="1" bind:value={workValue1} />
          <label for="email">E-mail:</label><input
            class="submitter"
            name="email"
            placeholder="email"
            bind:value={email1}
          /><br />
          <label for="pass">Password:</label><input
            class="submitter"
            name="pass"
            type="password"
            placeholder="비밀번호"
            bind:value={password1}
          /><br />
          <input class="submitter" type="submit" value="Post 1" />
        </form>
      </div>
      <div class="item">
        <h1>Workbench 2</h1>
        <form class="item" on:submit|preventDefault={post2}>
          Post address :
          <textarea rows="1" bind:value={workValue2} />
          <label for="instance-name">Instance name:</label><input
            class="submitter"
            name="instance-name"
            placeholder="instance name"
            bind:value={email2}
          /><br />
          <label for="instance-type">Instance type:</label><input
            class="submitter"
            name="instance-type"
            placeholder="instance type"
            bind:value={password2}
          /><br />
          <input class="submitter" type="submit" value="Post 2" />
        </form>
      </div>
    </div>
    <div class="workbench">
      <div class="item">
        <h1>Workbench 3</h1>

        <div class="get-item">
          <textarea rows="1" class="get-text" bind:value={getValue1} /><button
            class="get-btn"
            on:click={get1}>Get</button
          >
        </div>

        <div class="get-item">
          <textarea rows="1" class="get-text" bind:value={getValue2} />
          <button class="get-btn" on:click={get2}>Get</button>
        </div>
        <div class="get-item">
          <textarea rows="1" class="get-text" bind:value={getValue3} />
          <button class="get-btn" on:click={get3}>Get</button>
        </div>
        <div class="get-item">
          <textarea rows="1" class="get-text" bind:value={getValue4} />
          <button class="get-btn" on:click={get4}>Get</button>
        </div>
      </div>
      <div class="results">
        <h1 class="title">Result</h1>
        <ol>
          {#each results as result}
            <li class="result">{result}</li>
          {/each}
        </ol>
      </div>
    </div>
  </div>
</Window>

<style>
  .title {
    width: 100%;
  }
  .submitter {
    width: 80%;
  }
  .get-item {
    display: flex;
  }
  .get-text {
    width: 80%;
    display: inline-block;
    resize: none;
  }
  .get-btn {
    width: 20%;
    display: inline-block;
  }
  .container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 20px;
    box-sizing: border-box;
    /* justify-content: center; */
    /* align-items: center; */
    /* overflow: hidden; */
  }
  textarea {
    width: 90%;
    white-space: nowrap;
    overflow: hidden;
    resize: none;
  }
  .workbench {
    flex: 3;
    width: 100%;
    height: 100%;
    display: flex;
  }
  .item {
    height: 100%;
    width: 100%;
    flex: 1;
  }
  .results {
    flex: 2;
    width: 100%;
  }
</style>
